export default [
  {
    title: 'Devoluções e Trocas',
    icon: 'RotateCcwIcon',
    action: 'read',
    resource: 'Devolucoes',
    children: [
      {
        title: 'Solicitações',
        route: 'devolucoes',
        icon: 'CircleIcon',
        action: 'read',
        resource: 'Devolucoes',
        tenantPref: 'solicitacaoDevolucaoAtivo',
      },
      {
        title: 'Saldo de Devolução',
        route: 'devolucao-saldo',
        icon: 'CircleIcon',
        action: 'read',
        resource: 'DevolucaoSaldo',
      },
    ],
  },
];
